import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=6593a629&scoped=true"
import script from "./clause.vue?vue&type=script&lang=js"
export * from "./clause.vue?vue&type=script&lang=js"
import style0 from "./clause.vue?vue&type=style&index=0&id=6593a629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6593a629",
  null
  
)

export default component.exports